import { useRouteSection } from '@/hooks/useRouteSection';
import { useTranslation } from 'react-i18next';

export const InternationalCovidCoverages = () => {
  const routeSection = useRouteSection();
  const { t } = useTranslation('translation', {
    keyPrefix: 'covid',
  });

  return {
    title: t('coverage.title'),
    coverages: [
      {
        label: t('postpone.label'),
        remarks: null,
        insuredAmountData: [
          {
            classId: 1,
            amount: '₱ 10,000',
            remark: null,
            colspan: 1,
          },
          {
            classId: 2,
            amount: '₱ 25,000',
            remark: null,
            colspan: 1,
          },
          {
            classId: 3,
            amount: '₱ 50,000',
            remark: null,
            colspan: 1,
          },
        ],
      },
      {
        label: t('cancel.label'),
        remarks: null,
        insuredAmountData: [
          {
            classId: 1,
            amount: '₱ 10,000',
            remark: null,
            colspan: 1,
          },
          {
            classId: 2,
            amount: '₱ 25,000',
            remark: null,
            colspan: 1,
          },
          {
            classId: 3,
            amount: '₱ 50,000',
            remark: null,
            colspan: 1,
          },
        ],
      },
      {
        label: t('medical.label'),
        remarks: null,
        insuredAmountData: [
          {
            classId: 1,
            amount: '₱ 50,000',
            remark: null,
            colspan: 1,
          },
          {
            classId: 2,
            amount: '₱ 100,000',
            remark: null,
            colspan: 1,
          },
          {
            classId: 3,
            amount: '₱ 2,500,000',
            remark: null,
            colspan: 1,
          },
        ],
      },
      {
        label: t('quarantine.label'),
        remarks: null,
        insuredAmountData: [
          {
            classId: 1,
            amount: t('quarantine.amount', { amount: '-' }),
            remark: t('quarantine.remark', { amount: '-' }),
            colspan: 1,
          },
          {
            classId: 2,
            amount: t('quarantine.amount', { amount: '₱ 500' }),
            remark: t('quarantine.remark', { amount: '₱ 7,000' }),
            colspan: 1,
          },
          {
            classId: 3,
            amount: t('quarantine.amount', { amount: '₱ 1,000' }),
            remark: t('quarantine.remark', { amount: '₱ 14,000' }),
            colspan: 1,
          },
        ],
      },
      {
        label: t('emergency.label'),
        remarks: null,
        insuredAmountData: [
          {
            classId: 1,
            amount: '₱ 5,000',
            remark: null,
            colspan: 1,
          },
          {
            classId: 2,
            amount: '₱ 10,000',
            remark: null,
            colspan: 1,
          },
          {
            classId: 3,
            amount: '₱ 250,000',
            remark: null,
            colspan: 1,
          },
        ],
      },
      {
        label: t('travel.label'),
        remarks: null,
        insuredAmountData: [
          {
            classId: 1,
            amount: '₱ 10,000',
            remark: null,
            colspan: 1,
          },
          {
            classId: 2,
            amount: '₱ 25,000',
            remark: null,
            colspan: 1,
          },
          {
            classId: 3,
            amount: '₱ 50,000',
            remark: null,
            colspan: 1,
          },
        ],
      },
      {
        label: t('hospital.label'),
        remarks: null,
        insuredAmountData: [
          {
            classId: 1,
            amount: '₱ 5,000',
            remark: null,
            colspan: 1,
          },
          {
            classId: 2,
            amount: '₱ 10,000',
            remark: null,
            colspan: 1,
          },
          {
            classId: 3,
            amount: '₱ 25,000',
            remark: null,
            colspan: 1,
          },
        ],
      },
    ],
  };
};

export default InternationalCovidCoverages;
